import { Report } from '../../models/report.model';

export const getGarageTypeLabel = (code: string): string | undefined => {
  switch (code) {
    case Report.Characteristics.GarageType
      .CLOSED_BOX_COLLECTIVE_OR_INDIVIDUAL_GARAGE:
      return 'Box fermé dans un parking collectif ou garage individuel';
    case Report.Characteristics.GarageType.OPEN_AIR_PARKING_SPOT:
      return 'Emplacement à ciel ouvert';
    case Report.Characteristics.GarageType.COVERED_COLLECTIVE_PARKING:
      return 'Parking couvert dans un parking collectif';
    case Report.Characteristics.GarageType.GARAGE_BUILDING_LESS_THAN_500_M2:
      return 'Bâtiment à usage de garage sur un terrain ne dépassant pas 500 m²';
    case Report.Characteristics.GarageType.INDIVIDUAL_TWO_WHEELER_PARKING:
      return 'Emplacement individuel pour 2 roues';
    default:
      return undefined;
  }
};
